import { useEventScanner } from "@/stores/eventscanner";
export function setEventVerificationType(type){
    useEventScanner().setEventVerificationType(type);
}